import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { EventCard } from "@/pages/Events";
import { Panel } from "@/pages/portals/ui";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

export default function VolunteerPortal({ user }) {
  const qc = useQueryClient();
  const { data } = useQuery({ queryKey: ["portal", "volunteer"], queryFn: () => api.get("/portal/volunteer").then((r) => r.data) });
  const [ev, setEv] = useState(null);
  if (!data) return <p>Loading…</p>;
  const confirm = async () => {
    await api.post(`/events/${ev.id}/register`, { name: user.name, email: user.email, role: "volunteer" });
    toast.success("Signed up to volunteer");
    setEv(null);
    qc.invalidateQueries({ queryKey: ["portal", "volunteer"] });
  };
  return (
    <div className="space-y-6" data-testid="volunteer-portal">
      <Panel title="Volunteer opportunities" testid="volunteer-events">
        <div className="grid md:grid-cols-3 gap-3">
          {data.events.length ? data.events.map((e) => <EventCard key={e.id} e={e} onRegister={setEv} registered={data.registered_event_ids.includes(e.id)} />) : <p className="text-sm text-slate-500">No events scheduled yet — we'll post Safety Days and the Annual Walk here.</p>}
        </div>
      </Panel>
      <p className="text-xs text-slate-500">Volunteers do not perform fence installation, engineering, rescue instruction or other skilled work unless properly qualified and authorized.</p>
      {ev && (
        <Dialog open onOpenChange={() => setEv(null)}>
          <DialogContent className="rounded-2xl">
            <DialogHeader><DialogTitle className="font-display uppercase text-[#03045E]">Volunteer at {ev.title}?</DialogTitle></DialogHeader>
            <button onClick={confirm} className="rounded-full bg-[#03045E] text-white py-3 font-bold uppercase" data-testid="volunteer-confirm-button">Confirm</button>
          </DialogContent>
        </Dialog>
      )}
    </div>
  );
}
